import { Tabs, TabsProps, useTheme } from "@mui/material";

interface CustomColoredTabsProps extends TabsProps {
  hideIndicator?: boolean;
  autoScrollable?: boolean;
}

export const CustomColoredTabs = ({
  hideIndicator,
  autoScrollable,
  ...tabsProps
}: CustomColoredTabsProps) => {
  const theme = useTheme();

  return (
    <Tabs
      {...tabsProps}
      variant={autoScrollable ? "scrollable" : "standard"}
      scrollButtons="auto"
      slotProps={{
        indicator: {
          children: hideIndicator ? null : (
            <span
              data-testid="custom-colored-tabs-indicatorSpan"
              className="MuiTabs-indicatorSpan"
            />
          )
        }
      }}
      sx={{
        "& .MuiTabs-indicator": {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "transparent"
        },
        "& .MuiTabs-indicatorSpan": {
          width: "100%",
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.getContrastText(theme.palette.background.paper)
              : theme.palette.primary.main
        }
      }}
    />
  );
};
